import { Component, Injectable, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
  MatNativeDateModule,
  NativeDateAdapter,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ControlValueAccessorConnector } from '../utils/control-value-accessor-connector/control-value-accessor-connector';

export const ISO_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'yyyy-MM-dd',
  },
  display: {
    dateInput: { dateInput: 'iso-date' },
    monthLabel: { month: 'short' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};

@Injectable()
export class IsoDateAdapter extends NativeDateAdapter {
  override parse(value: unknown): Date | null {
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return null;
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
      if (match) {
        const [, year, month, day] = match;
        const parsed = new Date(Number(year), Number(month) - 1, Number(day));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
    }
    return super.parse(value);
  }

  override format(date: Date, displayFormat: object): string {
    if (
      typeof displayFormat === 'object' &&
      displayFormat !== null &&
      'dateInput' in displayFormat &&
      displayFormat.dateInput === 'iso-date'
    ) {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return super.format(date, displayFormat);
  }
}

@Component({
  selector: 'stena-date-picker',
  templateUrl: 'stena-date-picker.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StenaDatePickerComponent),
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: IsoDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: ISO_DATE_FORMATS,
    },
  ],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatDatepickerModule,
    ReactiveFormsModule,
  ],
})
export class StenaDatePickerComponent extends ControlValueAccessorConnector {
  @Input() label = '';
}
